import FloatConfigContainer from '../FloatConfigContainer/FloatConfigContainer';
import FloatConfigHeader from '../FloatConfigContainer/FloatConfigHeader/FloatConfigHeader';
import FloatConfigOption from '../FloatConfigContainer/FloatConfigOption/FloatConfigOption';
import useStateStore from 'services/store';
import FloatConfigTab from '../FloatConfigContainer/FloatConfigTab/FloatConfigTab';
import { useEffect, useState } from 'react';
import { ConfigDataTab } from 'services/types';

const Cuff = () => {
  const [cuffs, setCuffs] = useState<ConfigDataTab>();
  useEffect(() => {
    fetch('data/cuffs.json')
      .then((response) => response.json())
      .then((data) => {
        setCuffs(data);
      })
      .catch((error) => {
        console.error('Error fetching cuffs:', error);
      });
  }, []);

  const { activeProductData, activeFabric, setElbowPatch } = useStateStore();
  return (
    <FloatConfigContainer>
      <FloatConfigHeader />
      <div className="pre-body">
        <FloatConfigTab data={cuffs} />
        {activeProductData[activeFabric]?.cuff?.tab === 'long-sleeve' ? (
          <div className="elbow-patch">
            <label htmlFor="elbow-patch">Elbow Patch</label>
            <input
              onChange={setElbowPatch}
              checked={
                !!activeProductData[activeFabric]?.cuff?.elbowPatch
              }
              type="checkbox"
              id="elbow-patch"
              className="checkbox"
            />
          </div>
        ) : (
          ''
        )}

        {/* <div className="filter-container">
          <Button isIcon="left" icon={<img src="images/filter.svg" alt="" />}>
            FILTER
          </Button>
          <Button
            isIcon="left"
            icon={<span>&#10006;</span>}
            variant="secondary"
          >
            RESET FILTER
          </Button>
        </div> */}
      </div>
      <div className="body">
        <div className="list-container">
          {/* fabrics?.[
            activeProductData?.[activeFabric]?.fabric?.tab!
          ]?.data?.map */}
          {cuffs?.[activeProductData?.[activeFabric]?.cuff?.tab!]?.data?.map(
            (fab) => (
              <FloatConfigOption
                key={fab.id}
                item={fab}
                procedure="changeCuff"
                type="cuff"
              />
            )
          )}
        </div>
      </div>
    </FloatConfigContainer>
  );
};

export default Cuff;
